import React, { createContext, useContext, useState } from 'react';

const LanguageContext = createContext();

const LANGUAGES = ['it', 'de', 'en'];

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState('it');

  const cycleLanguage = () => {
    const currentIndex = LANGUAGES.indexOf(language);
    const nextIndex = (currentIndex + 1) % LANGUAGES.length;
    setLanguage(LANGUAGES[nextIndex]);
  };

  const getNextLanguage = () => {
    const currentIndex = LANGUAGES.indexOf(language);
    const nextIndex = (currentIndex + 1) % LANGUAGES.length;
    return LANGUAGES[nextIndex].toUpperCase();
  };

  return (
    <LanguageContext.Provider value={{ language, setLanguage, cycleLanguage, getNextLanguage, LANGUAGES }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};
